import Modal from '../../Unknown/Modal'
import { useAppDispatch, useAppSelector } from '../../../modules/store/hooks'
import { modalsSlice } from '../../../modules/store/reducers/modalsSlice'
import { CircularProgress, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { DragEvent, useRef, useState } from 'react'
import pdfIcon from '../../../assets/images/pdfIcon.png'
import translate from '../../../i18n/translate'
import { organizerApi } from '../../../modules/services/organizerService'
import { OrganizerFile } from '../OrganizerFilesModal'

type UploadNewOrganizerFileModalProps = {
  userId: number
  onSuccess: (newFile: OrganizerFile) => void
}

export default function UploadNewOrganizerFileModal ({
  userId,
  onSuccess
}: UploadNewOrganizerFileModalProps) {
  const dispatch = useAppDispatch()
  const { toggleUploadOrganizerFileModal } = modalsSlice.actions
  const visible = useAppSelector(state => state.modalsReducer.uploadOrganizerFile)

  const inputFile = useRef<HTMLInputElement | null>(null)

  const [uploadFile, { isLoading: isFileUploading }] =
    organizerApi.useUploadOrganizerFileMutation()

  const [fileName, setFileName] = useState<string | null>(null)

  const [drag, setDrag] = useState(false)
  function dragStartHandler (e: DragEvent<HTMLDivElement>) {
    e.preventDefault()
    setDrag(true)
  }

  function dragLeaveHandler (e: DragEvent<HTMLDivElement>) {
    e.preventDefault()
    setDrag(false)
  }

  function onDropHandler (e: DragEvent<HTMLDivElement>) {
    e.preventDefault()
    const file = e.dataTransfer.files[0]
    onFileUploading(file)
    setFileName(file.name)

    setDrag(false)
  }

  function onUploadClick () {
    inputFile?.current?.click()
  }

  function handleExplorerInputChange (event: any) {
    const file = event.target.files[0]

    onFileUploading(file)
  }

  const onFileUploading = async (file: File) => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      const newFile = await uploadFile({ userId, data: formData }).unwrap()

      onSuccess(newFile)
      dispatch(toggleUploadOrganizerFileModal())
    } catch (error) {}
  }

  return (
    <Modal
      title={translate('uploadNewOrganizerFileModalTitle')}
      visible={visible === 'open'}
      style={{ maxWidth: '400px', zIndex: 1001 }}
      setVisible={() => dispatch(toggleUploadOrganizerFileModal())}
    >
      <input
        ref={inputFile}
        onChange={handleExplorerInputChange}
        type='file'
        name='name'
        style={{ display: 'none' }}
        accept='application/pdf'
      />
      <div
        style={{
          backgroundColor: 'orange',
          width: '100%',
          cursor: 'pointer',
          padding: '10px'
        }}
        onClick={onUploadClick}
      >
        <Box
          sx={{
            height: '500px',
            backgroundColor: 'white',
            display: 'flex',
            justifyContent: 'space-around',
            flexDirection: 'column',
            padding: '10px'
          }}
        >
          <Box
            sx={{
              height: '400px',
              width: '100%',
              border: '1px solid orange',
              marginBottom: '10px'
            }}
          >
            {isFileUploading ? (
              <Box
                width='100%'
                height='100%'
                display='flex'
                alignItems='center'
                justifyContent='center'
              >
                <CircularProgress color='warning' size={50} />
              </Box>
            ) : drag ? (
              <div
                onDragStart={e => dragStartHandler(e)}
                onDragLeave={e => dragLeaveHandler(e)}
                onDragOver={e => dragStartHandler(e)}
                onDrop={e => onDropHandler(e)}
                style={{ width: '100%', height: '100%' }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    height: '100%',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Typography fontSize={30}>
                    {translate('uploadNewOrganizerFileModalTitleDropOrClickFileHere')}
                  </Typography>
                </Box>
              </div>
            ) : fileName ? (
              <div
                onDragStart={e => dragStartHandler(e)}
                onDragLeave={e => dragLeaveHandler(e)}
                onDragOver={e => dragStartHandler(e)}
                onDrop={e => onDropHandler(e)}
                style={{ width: '100%', height: '100%' }}
              >
                <Box
                  sx={{
                    height: '330px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <img
                    src={pdfIcon}
                    alt={fileName}
                    style={{ height: '200px' }}
                  />
                </Box>
                <Typography textAlign='center'>{fileName}</Typography>
              </div>
            ) : (
              <div
                onDragStart={e => dragStartHandler(e)}
                onDragLeave={e => dragLeaveHandler(e)}
                onDragOver={e => dragStartHandler(e)}
                style={{ width: '100%', height: '100%' }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    height: '100%',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Typography fontSize={30}>
                    {translate('uploadNewOrganizerFileModalTitleDropFileHere')}
                  </Typography>
                </Box>
              </div>
            )}
          </Box>
        </Box>
      </div>
    </Modal>
  )
}
